/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportTypeBo } from '../../models/report-type-bo';

export interface GetTypeNst$Params {
}

export function getTypeNst(http: HttpClient, rootUrl: string, params?: GetTypeNst$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportTypeBo>>> {
  const rb = new RequestBuilder(rootUrl, getTypeNst.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ReportTypeBo>>;
    })
  );
}

getTypeNst.PATH = '/svg/nst/type';
